import { useTranslation } from "@i18n";
import { useState } from "react";
import RadioButton from "@CubeComponents/Mui_Form/RadioButton";
import ModalStateDialogComponent from "@CubeComponents/html/modal/ModalWithState";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { FormControlLabel, RadioGroup } from "@mui/material";
function RecursiveConfirmationPopup({
  header,
  handleSubmit,
  handleClose,
  toggleIsRecursive,
  module,
  radioButtonLabels = [],
  headerTitle,
  additionalTextBeforeOptions = "",
  optionButtonsText = [],
  isRecursive,
  recursiveOverrideWarningMessage,
}: any) {
  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);

    try {
      await handleSubmit();
    } finally {
      setIsSubmitting(false);
    }
  };

  const modelContent = () => {
    return (
      <div className="flex flex-col gap-6">
        {additionalTextBeforeOptions && <span>{additionalTextBeforeOptions}</span>}
        <div className="flex flex-col gap-4">
          <RadioGroup onChange={toggleIsRecursive}>
            <FormControlLabel
              checked={!isRecursive}
              value="retain"
              control={<RadioButton />}
              label={
                radioButtonLabels[1] ||
                t("default_no_override_template", {
                  header: header,
                  module: module,
                })
              }
              sx={{ mb: "1rem" }}
            />
            <FormControlLabel
              value="overRide"
              checked={isRecursive}
              control={<RadioButton />}
              label={
                radioButtonLabels[0] ||
                t("default_yes_override_template", {
                  header: header,
                })
              }
            />
          </RadioGroup>
        </div>
        {isRecursive && (
          <div className="rounded-lg p-3 text-sm bg-banner_color_yellow_translucent">
            {recursiveOverrideWarningMessage}
          </div>
        )}
      </div>
    );
  };

  const footerContent = () => (
    <div className="flex gap-4">
      <ButtonComponent
        buttonType={BUTTON_TYPES.GRADIENT_BUTTON}
        onClick={onSubmit}
        data-testid="nextAddUserBtn"
        loading={isSubmitting}
      >
        {optionButtonsText.length > 0 ? optionButtonsText[0] : t("Submit")}
      </ButtonComponent>
      <ButtonComponent buttonType={BUTTON_TYPES.BORDER_BUTTON} onClick={handleClose} data-testid="cancelAddUserBtn">
        {optionButtonsText.length > 1 ? optionButtonsText[1] : t("Cancel")}
      </ButtonComponent>
    </div>
  );

  return (
    <ModalStateDialogComponent
      isVisible
      width="40%"
      headerTitle={
        headerTitle ||
        t("recurscive_confirmation_popup_default_header_text", {
          header: header,
          module: module,
        })
      }
      onCancel={handleClose}
      modelContent={modelContent()}
      footerContent={footerContent()}
    />
  );
}

export default RecursiveConfirmationPopup;
